import { render, staticRenderFns } from "./ReplicantiGainText.vue?vue&type=template&id=2d743e12&scoped=true&"
import script from "./ReplicantiGainText.vue?vue&type=script&lang=js&"
export * from "./ReplicantiGainText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d743e12",
  null
  
)

export default component.exports